import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AppPage } from 'src/components/AppPage';

export const Route = createFileRoute('/_auth/_only-header/store/connect-offer')(
  {
    component: () => {
      return (
        <AppPage.Container className="flex min-h-[calc(100dvh-64px)] flex-col">
          <Outlet />
        </AppPage.Container>
      );
    },
  }
);
